import React, {  useRef,useEffect, useState, useCallback  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton'; 
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import FormSearchStores from "pages/forms/editOrNewFormDI/FormSearchStores";
import FormSearchStoresNimaAddresses from "pages/forms/editOrNewFormDI/FormSearchStoresNimaAddress";
import FormSearchStoresAddresses from "./FormSearchStoresAddress";
import FormSearchStoreVehicles from "./FormSearchVehicles";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0,
    "province_name":""
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];
 
const FormCreateOrEditDestTras = ({formForm,setFormForm,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormForm,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect,hasbeenshared}) => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
     
    const dest_tras_view_name = useSelector((state) => state.formatDIUser.dest_tras_view_name); 
    const dest_tras_view_contactname = useSelector((state) => state.formatDIUser.dest_tras_view_contactname); 
    const dest_tras_view_address = useSelector((state) => state.formatDIUser.dest_tras_view_address); 
    const dest_tras_view_phone = useSelector((state) => state.formatDIUser.dest_tras_view_phone); 
    const dest_tras_view_email = useSelector((state) => state.formatDIUser.dest_tras_view_email); 
    const dest_tras_view_nima = useSelector((state) => state.formatDIUser.dest_tras_view_nima); 
    const dest_tras_view_cnae = useSelector((state) => state.formatDIUser.dest_tras_view_cnae); 
    const dest_tras_view_inscription = useSelector((state) => state.formatDIUser.dest_tras_view_inscription); 
    const dest_tras_view_opt = useSelector((state) => state.formatDIUser.dest_tras_view_opt); 
    const dest_tras_view_licenseplate = useSelector((state) => state.formatDIUser.dest_tras_view_licenseplate); 
    const dest_tras_view_economicactivity = useSelector((state) => state.formatDIUser.dest_tras_view_economicactivity); 

    const dest_tras_handle_documnettype= useSelector((state) => state.formatDIUser.dest_tras_handle_documnettype); 
    const dest_tras_handle_documentid= useSelector((state) => state.formatDIUser.dest_tras_handle_documentid); 
    const dest_tras_handle_tradename= useSelector((state) => state.formatDIUser.dest_tras_handle_tradename); 
    const dest_tras_handle_name= useSelector((state) => state.formatDIUser.dest_tras_handle_name); 
    const dest_tras_handle_contactname= useSelector((state) => state.formatDIUser.dest_tras_handle_contactname); 
    const dest_tras_handle_address= useSelector((state) => state.formatDIUser.dest_tras_handle_address); 
    const dest_tras_handle_phone= useSelector((state) => state.formatDIUser.dest_tras_handle_phone); 
    const dest_tras_handle_email= useSelector((state) => state.formatDIUser.dest_tras_handle_email); 
    const dest_tras_handle_nima= useSelector((state) => state.formatDIUser.dest_tras_handle_nima); 
    const dest_tras_handle_cnae= useSelector((state) => state.formatDIUser.dest_tras_handle_cnae); 
    const dest_tras_handle_inscription= useSelector((state) => state.formatDIUser.dest_tras_handle_inscription); 
    const dest_tras_handle_opt= useSelector((state) => state.formatDIUser.dest_tras_handle_opt); 
    const dest_tras_handle_licenseplate= useSelector((state) => state.formatDIUser.dest_tras_handle_licenseplate); 
    const dest_tras_handle_economicactivity= useSelector((state) => state.formatDIUser.dest_tras_handle_economicactivity); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);     
    const [showModalSearchVehicles, setShowModalSearchVehicles] = useState(false); 
    const dispatch = useDispatch(); 
    const [postalCodeDestToSelect,setPostalCodeDestToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeDest, setFilteredpostalCodeDest] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeDest, setHighlightedIndexPostalCodeDest] = useState(-1); // Índice de la opción resaltada 
    const [documentIdDestToSelect,setDocumentIdDestToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdDest, setFilteredDocumentIdDest] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdDest, setHighlightedIndexDocumentIdDest] = useState(-1); // Índice de la opción resaltada 
    const [tradenameDestToSelect,setTradenameDestToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedDest, setFilteredTradenamedDest] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedDest, setHighlightedIndexTradenamedDest] = useState(-1); // Índice de la opción resaltada 
    const [destTrasNimaToSelect,setDestTrasNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredDestTrasNima, setFilteredDestTrasNima] = useState([]); // Opciones filtradas
    const [highlightedIndexDestTrasNima, setHighlightedIndexDestTrasNima] = useState(-1); // Índice de la opción resaltada 
           
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
        const timeoutRef = useRef(null);
        return useCallback((...args) => {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
            callback(...args);
            }, delay);
        }, [callback, delay]);
    };

    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeDest([]);
            setHighlightedIndexPostalCodeDest(-1);
        return;
        }
        const filtered = postalCodeDestToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeDest(filtered);
        setHighlightedIndexPostalCodeDest(0);
    }, 300); 
    const handleSelectPostalCodeDest = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
            ...formForm,
            dest_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            dest_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE),
            dest_tras_province_name: postal.province_name || DEFAULTPROVINCE_NAME
        }));
        setFilteredpostalCodeDest([]);
        setHighlightedIndexPostalCodeDest(-1);
    }; 
    const handleKeyDownDPostalCodeDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeDest.length === 0 && formForm.dest_tras_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeDest(postalCodeDestToSelect);
            setHighlightedIndexPostalCodeDest(0);
        } else {
            setHighlightedIndexPostalCodeDest((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexPostalCodeDest((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeDest >= 0) {
            if (highlightedIndexPostalCodeDest >= 0 && highlightedIndexPostalCodeDest < filteredpostalCodeDest.length) {
                handleSelectPostalCodeDest(filteredpostalCodeDest[highlightedIndexPostalCodeDest]);
            }
        } else if (event.key === "Escape") {
        const isValid = postalCodeDestToSelect.some((postal) => {
            if (!postal || !postal.postalcode) return false; 
            const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.dest_tras_postalcode_code.toUpperCase();
            return normalizedPostalCodeId === normalizedInputId;
        }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm,
                dest_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                dest_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                dest_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                dest_tras_province_id: Number(DEFAULTPROVINCE),
                dest_tras_province_name: DEFAULTPROVINCE_NAME
            }));
        } 
        setFilteredpostalCodeDest([]);
        setHighlightedIndexPostalCodeDest(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchDocumentIdDest = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdDest([]);
            setHighlightedIndexDocumentIdDest(-1);
            return;
        }
        const filtered = documentIdDestToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentId = store.documentid.toUpperCase();
            return documentId.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdDest(filtered);
        setHighlightedIndexDocumentIdDest(0);
    }, 300); 
    const handleSelectDocumentIdDest = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        dest_tras_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdDest([]);
        setHighlightedIndexDocumentIdDest(-1);
    }; 
    const handleKeyDownDocumentIdDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdDest.length === 0 && formForm.dest_tras_documentid.trim() === "") {
            setFilteredDocumentIdDest(documentIdDestToSelect);
            setHighlightedIndexDocumentIdDest(0);
        } else {
            setHighlightedIndexDocumentIdDest((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexDocumentIdDest((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdDest >= 0) {
        if (highlightedIndexDocumentIdDest >= 0 && highlightedIndexDocumentIdDest < filteredDocumentIdDest.length) {
            handleSelectDocumentIdDest(filteredDocumentIdDest[highlightedIndexDocumentIdDest]);
        }
        } else if (event.key === "Escape") {
        const isValid = documentIdDestToSelect.some((store) => {
            if (!store || !store.documentid) return false; 
            const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.dest_tras_documentid.toUpperCase();
            return normalizedStoreId === normalizedInputId;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            dest_tras_documentid: "",
            }));
        } 
        setFilteredTradenamedDest([]);
        setHighlightedIndexDocumentIdDest(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradenameDest= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedDest([]);
            setHighlightedIndexTradenamedDest(-1);
        return;
        }
        const filtered = tradenameDestToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedDest(filtered);
        setHighlightedIndexTradenamedDest(0);
    }, 300); 
    const handleSelectTradeNameDest = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        dest_tras_tradename: store.tradename || "",
        dest_tras_documentid: store.documentid || formForm.dest_tras_documentid,
        
        }));
        setFilteredTradenamedDest([]);
        setHighlightedIndexTradenamedDest(-1);
    }; 
    const handleKeyDownTradenameDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedDest.length === 0 && formForm.dest_tras_tradename.trim() === "") {
            setFilteredTradenamedDest(tradenameDestToSelect);
            setHighlightedIndexTradenamedDest(0);
        } else {
            setHighlightedIndexTradenamedDest((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedDest((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedDest >= 0) {
        if (highlightedIndexTradenamedDest >= 0 && highlightedIndexTradenamedDest < filteredTradenamedDest.length) {
            handleSelectTradeNameDest(filteredTradenamedDest[highlightedIndexTradenamedDest]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameDestToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formForm.dest_tras_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            dest_tras_tradename: "",
            }));
        } 
        setFilteredTradenamedDest([]);
        setHighlightedIndexTradenamedDest(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchDestTrasNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDestTrasNima([]);
            setHighlightedIndexDestTrasNima(-1);
        return;
        }
        const filtered = destTrasNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredDestTrasNima(filtered);
        setHighlightedIndexDestTrasNima(0);
    }, 300); 
    const handleSelectDestTrasNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        dest_tras_nima: nt.nima || ""
        }));
        setFilteredDestTrasNima([]);
        setHighlightedIndexDestTrasNima(-1);
    }; 
    const handleKeyDownDestTrasNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredDestTrasNima.length === 0 && formForm.dest_tras_nima.trim() === "") {
                const filtered = destTrasNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredDestTrasNima(filtered);
                setHighlightedIndexDestTrasNima(0);
            } else {
                setHighlightedIndexDestTrasNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredDestTrasNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDestTrasNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDestTrasNima >= 0) {
            if (highlightedIndexDestTrasNima >= 0 && highlightedIndexDestTrasNima < filteredDestTrasNima.length) {
                handleSelectDestTrasNima(filteredDestTrasNima[highlightedIndexDestTrasNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = destTrasNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.dest_tras_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm, 
                dest_tras_nima: ""
            }));
        } 
        setFilteredDestTrasNima([]);
        setHighlightedIndexDestTrasNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    const handleBlur = useCallback((event) => {
        if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeDest([]);
            setHighlightedIndexPostalCodeDest(-1);
            setFilteredDocumentIdDest([]);
            setHighlightedIndexDocumentIdDest(-1);
            setFilteredTradenamedDest([]);
            setHighlightedIndexTradenamedDest(-1); 
            setFilteredDestTrasNima([]);
            setHighlightedIndexDestTrasNima(-1);  
        }
    }, []);
    
    const handleChangeSelectDocumentType_Dest_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            dest_tras_documnettype_id:event.target.value
        }));
    };
    const handleBlurSelectDocumentType_Dest_Tras = (e) => {
        handleChangeSelectDocumentType_Dest_Tras(e);
    };
    
    const handleChangeSelectRoadType_Dest_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            dest_tras_roadtype_id : event.target.value 
        }));
    };
    const handleBlurSelectRoadType_Dest_Tras = (e) => {
        handleChangeSelectRoadType_Dest_Tras(e);
        setErrorsForm(validateFormForm());
    };
       
    const handleChangeSelectCommunity_Dest_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            dest_tras_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Dest_Tras = (e) => {
        handleChangeSelectCommunity_Dest_Tras(e);
        setErrorsForm(validateFormForm());
    };

    const handleChangeDataEditForm_Dest_Tras = (e) => {
        const { name, value } = e.target;
        setFormForm(formForm => ({
          ...formForm,
          [name]: value,
        }));
    };
    const handleBlurDataEditForm_Dest_Tras = (e) => {
        handleChangeDataEditForm_Dest_Tras(e);
        setErrorsForm(validateFormForm());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setShowModalSearchStoresNimaAddress(true);
    };

    const searchFormVehicles = (event) => {
        setShowModalSearchVehicles(true);
    };

    const deleteDateDestTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            dest_tras_store_id:0,
            dest_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            dest_tras_documentid:"",
            dest_tras_tradename: "",
            dest_tras_name: "",
            dest_tras_contactname: "",
            dest_tras_roadtype_id: Number(DEFAULTROADTYE),
            dest_tras_street: "",
            dest_tras_country_id: Number(DEFAULTCOUNTRY),
            dest_tras_country_name:DEFAULTCOUNTRY_NAME,
            dest_tras_province_id: Number(DEFAULTPROVINCE),
            dest_tras_province_name:DEFAULTPROVINCE_NAME,
            dest_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            dest_tras_community_id: Number(DEFAULTCOMMUNITY),
            dest_tras_community_name: DEFAULTCOMMUNITY_NAME,
            dest_tras_phone: "",
            dest_tras_email: "",
            dest_tras_nima: "",
            dest_tras_cnae: "",
            dest_tras_inscription: "",
            dest_tras_opt: 0,
            dest_tras_licenseplate: "",
            dest_tras_economicactivity:""
        }));
        setErrorsForm(validateFormForm());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            dest_tras_store_id:"",
            dest_tras_documnettype_id: "",
            dest_tras_documentid:"",
            dest_tras_tradename: "",
            dest_tras_name: "",
            dest_tras_contactname: "",
            dest_tras_roadtype_id: "",
            dest_tras_street: "",
            dest_tras_country_id: "",
            dest_tras_province_id: "",
            dest_tras_postalcode_id: "",
            dest_tras_postalcode_code:"",
            dest_tras_community_id: "",
            dest_tras_phone: "",
            dest_tras_email: "",
            dest_tras_nima: "",
            dest_tras_cnae: "",
            dest_tras_inscription: "",
            dest_tras_opt: "",
            dest_tras_licenseplate: "",
            dest_tras_economicactivity:""
        }));
    };

    const deleteDataSteetDestTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            dest_tras_roadtype_id: Number(DEFAULTROADTYE),
            dest_tras_street: "",
            dest_tras_country_id: Number(DEFAULTCOUNTRY),
            dest_tras_country_name:DEFAULTCOUNTRY_NAME,
            dest_tras_province_id: Number(DEFAULTPROVINCE),
            dest_tras_province_name:DEFAULTPROVINCE_NAME,
            dest_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            dest_tras_community_id: Number(DEFAULTCOMMUNITY),
            dest_tras_community_name: DEFAULTCOMMUNITY_NAME,
            dest_tras_nima: "", 
            dest_tras_inscription: "",
            dest_tras_opt: 0,
        }));
        setErrorsForm(validateFormForm());
    };

    const deleteDataVehicleDestTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
          dest_tras_licenseplate: ""
        }));
        setErrorsForm(validateFormForm());
    };

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`form/getexiststorebynumberdocument/`,token,formForm.dest_tras_documentid.replace(/[.\-/\\|]/g, ""));
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formForm.dest_tras_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`form/getformstorebynumberdocument`,token,formForm.dest_tras_documentid.replace(/[.\-/\\|]/g, ""),4);
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormForm(formForm => ({
                            ...formForm,
                            dest_tras_store_id: getData.store_id,
                            dest_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            dest_tras_tradename: getData.tradename,
                            dest_tras_name: getData.name,
                            dest_tras_contactname: getData.contacperson,
                            dest_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            dest_tras_street: getData.street,
                            dest_tras_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            dest_tras_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            dest_tras_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            dest_tras_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            dest_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            dest_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            dest_tras_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            dest_tras_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            dest_tras_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name,  
                            dest_tras_phone: getData.phone,
                            dest_tras_email: getData.email,
                            dest_tras_nima: getData.nima_dest_tras,
                            dest_tras_cnae: getData.cnae,
                            dest_tras_inscription: getData.pygr_dest_tras,
                            dest_tras_opt: getData.opt_dest_tras,
                            dest_tras_licenseplate: getData.licenseplate,
                            dest_tras_economicactivity:getData.economicactivity
                        }));
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formForm.dest_tras_documentid && formForm.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            }
        }
        return () => { isMounted = false };
     }, [t,token,dispatch,expanded,formForm.dest_tras_documentid,errorsForm.dest_tras_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,DEFAULTPROVINCE,setFormForm,formForm.dest_tras_store_id,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);
      
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdDest = async () => {
            try {
            const getData = await helpHttp().get2(ENDPOINT,`form/getlistdocumentidformdi/`,token,
                (formForm.dest_tras_documentid!==undefined && formForm.dest_tras_documentid!==null && formForm.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setDocumentIdDestToSelect(getData); 
            }
            } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formForm.dest_tras_documentid && formForm.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdDest();
            }
        } else{
            setDocumentIdDestToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.dest_tras_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameDest = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlisttradenameformdi/`,token,
                    (formForm.dest_tras_tradename!==undefined && formForm.dest_tras_tradename!==null && formForm.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameDestToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formForm.dest_tras_tradename && formForm.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameDest();
            }
        } else{
            setTradenameDestToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.dest_tras_tradename,expanded]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAut = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlistpostalcodeformdi/`,token,
                    (formForm.dest_tras_postalcode_code!==undefined && formForm.dest_tras_postalcode_code!==null && formForm.dest_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.dest_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeDestToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
            if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formForm.dest_tras_postalcode_code && formForm.dest_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAut();
            } 
        } else{
            setPostalCodeDestToSelect(initialPostalCodesToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.dest_tras_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormForm]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaDestTras = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchdcs/getlistnimas`,token,formForm.dest_tras_store_id, 
                    (formForm.dest_tras_nima!==undefined && formForm.dest_tras_nima!==null && formForm.dest_tras_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.dest_tras_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setDestTrasNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formForm.dest_tras_store_id && formForm.dest_tras_store_id!==null && formForm.dest_tras_store_id!=="" && formForm.dest_tras_store_id!=="0" && formForm.dest_tras_store_id!==0){
                fetchDataNimaDestTras(); 
            }else{
                setDestTrasNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm,expanded,setFormForm,formForm.dest_tras_store_id]);
        
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_DocuentType')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField autoComplete="off"
                    id="dest_tras_documnettype_id"
                    name="dest_tras_documnettype_id"
                    value={ (formForm.dest_tras_documnettype_id === undefined || formForm.dest_tras_documnettype_id ===null || formForm.dest_tras_documnettype_id ===""
                        || formForm.dest_tras_documnettype_id ==="0" || formForm.dest_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formForm.dest_tras_documnettype_id}
                    inputProps={{ style: {width: 100,  fontSize: '18px'}, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    variant="outlined"
                    onBlur={handleBlurSelectDocumentType_Dest_Tras}
                    onChange={handleChangeSelectDocumentType_Dest_Tras}
                    disabled={!dest_tras_handle_documnettype || hasbeenshared}
                    helperText={errorsForm.dest_tras_documnettype_id!=null && errorsForm.dest_tras_documnettype_id!==""?t(errorsForm.dest_tras_documnettype_id):""}
                    select
                    SelectProps={{
                        native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                        value: (formForm.dest_tras_documnettype_id === undefined || formForm.dest_tras_documnettype_id ===null || formForm.dest_tras_documnettype_id ===""
                            || formForm.dest_tras_documnettype_id ==="0" || formForm.dest_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formForm.dest_tras_documnettype_id
                    }}>
                    <MenuItem key={0} value=""/>
                    {documentTypesToSelect.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>  
                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CIF')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <span style={{ position: "relative" }}>
                    <TextField autoComplete="off"
                        id="dest_tras_documentid"
                        name="dest_tras_documentid"
                        value={formForm.dest_tras_documentid}
                        onChange={(e) => {
                            setFormForm(prev => ({
                            ...prev,
                            dest_tras_documentid: e.target.value.toUpperCase()
                            }));
                            debouncedHandleSearchDocumentIdDest(e.target.value);
                        }}
                        onKeyDown={handleKeyDownDocumentIdDest}
                        onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                            handleBlur();
                            }
                        }}
                        label={errorsForm.dest_tras_documentid!=null && errorsForm.dest_tras_documentid!==""?t(errorsForm.dest_tras_documentid):t('PlaceHolder_FORM_CIF')}
                        placeholder={t('PlaceHolder_FORM_CIF')}
                        variant="standard"
                        inputProps={{ style: {width: i18n.language==='es'?245:285,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        disabled={!dest_tras_handle_documentid || hasbeenshared}
                    />  
                    {/* Desplegable dinámico */}
                    {filteredDocumentIdDest.length > 0 && (
                        <div
                            className="dropdown-class"
                            style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "750px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                            }}
                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                        >
                            {filteredDocumentIdDest.map((store, index) => (
                            <MenuItem
                                key={store.id}
                                onClick={() => handleSelectDocumentIdDest(store)}
                                style={{
                                    cursor: "pointer",
                                    padding: "8px",
                                    borderBottom: "1px solid #eee",
                                    fontSize: '18px',
                                    backgroundColor:
                                    index === highlightedIndexDocumentIdDest ? "#4e73df" : "transparent",
                                    color: index === highlightedIndexDocumentIdDest ? "white" : "black",
                                }}
                            >
                                {store.documentid} - {store.tradename}
                            </MenuItem>
                            ))}
                        </div>
                    )}
                </span> 
                &nbsp;&nbsp;
               <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDateDestTras}>
                    <DeleteIcon  style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                    <IconButton  size="small" className={`edit-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={searchFormStore}>
                        <SearchIcon  style={{fontSize: 28}}/>
                    </IconButton>
                }
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_TRADENAME')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <span style={{ position: "relative" }}>
                    <TextField autoComplete="off"
                        id="dest_tras_tradename"
                        name="dest_tras_tradename"
                        value={formForm.dest_tras_tradename}
                        onChange={(e) => {
                            setFormForm(prev => ({
                            ...prev,
                            dest_tras_tradename: e.target.value.toUpperCase()
                            }));
                            debouncedHandleSearchTradenameDest(e.target.value);
                        }}
                        onKeyDown={handleKeyDownTradenameDest}
                        onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                            handleBlur();
                            }
                        }}
                        label={errorsForm.dest_tras_tradename!=null && errorsForm.dest_tras_tradename!==""?t(errorsForm.dest_tras_tradename):t('PlaceHolder_FORM_TRADENAME')}
                        placeholder={t('PlaceHolder_FORM_TRADENAME')}
                        variant="standard"
                        inputProps={{ style: {width: i18n.language==='es'?720:696,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        disabled={!dest_tras_handle_tradename || hasbeenshared}
                    />  
                    {/* Desplegable dinámico */}
                    {filteredTradenamedDest.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "150%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedDest.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameDest(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedDest ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedDest ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span> 
                </div>
            </div>
            {dest_tras_view_name &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="dest_tras_name" 
                        name="dest_tras_name"
                        value={formForm.dest_tras_name}
                        inputProps={{ style: {width: i18n.language==='es'?674:719,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_name!=null && errorsForm.dest_tras_name!==""?t(errorsForm.dest_tras_name):t('PlaceHolder_FORM_NAME')}
                        placeholder={t('PlaceHolder_FORM_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Dest_Tras}
                        onChange={handleChangeDataEditForm_Dest_Tras}
                        disabled={!dest_tras_handle_name || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {dest_tras_view_contactname &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="dest_tras_contactname" 
                        name="dest_tras_contactname"
                        value={formForm.dest_tras_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?657:702,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_contactname!=null && errorsForm.dest_tras_contactname!==""?t(errorsForm.dest_tras_contactname):t('PlaceHolder_FORM_CONTACT')}
                        placeholder={t('PlaceHolder_FORM_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Dest_Tras}
                        onChange={handleChangeDataEditForm_Dest_Tras}
                        disabled={!dest_tras_handle_contactname || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {dest_tras_view_address &&
                <>
                    <div className="row p-2"> 
                        <div className="form-group">
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_RoadType')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField autoComplete="off"
                            id="dest_tras_roadtype"
                            name="dest_tras_roadtype"
                            value={ (formForm.dest_tras_roadtype_id === undefined || formForm.dest_tras_roadtype_id ===null || formForm.dest_tras_roadtype_id ===""
                                || formForm.dest_tras_roadtype_id ==="0" || formForm.dest_tras_roadtype_id ===0)?"":formForm.dest_tras_roadtype_id}
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            variant="outlined"
                            onBlur={handleBlurSelectRoadType_Dest_Tras}
                            onChange={handleChangeSelectRoadType_Dest_Tras}
                            disabled={!dest_tras_handle_address || hasbeenshared}
                            helperText={errorsForm.dest_tras_roadtype_id!=null && errorsForm.dest_tras_roadtype_id!==""?t(errorsForm.dest_tras_roadtype_id):""}
                            select
                            SelectProps={{
                                native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                value: (formForm.dest_tras_roadtype_id === undefined || formForm.dest_tras_roadtype_id ===null || formForm.dest_tras_roadtype_id ===""
                                    || formForm.dest_tras_roadtype_id ==="0" || formForm.dest_tras_roadtype_id ===0)?"": formForm.dest_tras_roadtype_id
                            }}>
                            <MenuItem key={0} value=""/>
                            {roadTypesToSelect.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </MenuItem>
                            ))}
                        </TextField>  
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Address')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField autoComplete="off"
                            id="dest_tras_street" 
                            name="dest_tras_street"
                            value={formForm.dest_tras_street}
                            inputProps={{ style: {width: i18n.language==='es'?361:374,  fontSize: '18px', }, maxLength: 250 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.dest_tras_street!=null && errorsForm.dest_tras_street!==""?t(errorsForm.dest_tras_street):t('PlaceHolder_FORM_Address')}
                            placeholder={t('PlaceHolder_FORM_Address')}
                            variant="standard"
                            onBlur={handleBlurDataEditForm_Dest_Tras}
                            onChange={handleChangeDataEditForm_Dest_Tras}
                            disabled={!dest_tras_handle_address || hasbeenshared}
                        />
                        </div>
                        &nbsp;&nbsp;
                        <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDataSteetDestTras}>
                            <DeleteIcon style={{fontSize: 28}}/>
                        </IconButton>
                        &nbsp;&nbsp;
                        {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&& formForm.dest_tras_documentid!==undefined && formForm.dest_tras_documentid!=="") ?
                            <IconButton  size="small" className={`edit-${
                               (formForm.dest_tras_store_id===undefined
                                || formForm.dest_tras_store_id===""
                                || formForm.dest_tras_store_id==="0"
                                || formForm.dest_tras_store_id===0  || hasbeenshared)? "noselect-button": "select-button" }`}
                                disabled={(formForm.dest_tras_store_id===undefined
                                || formForm.dest_tras_store_id===""
                                || formForm.dest_tras_store_id==="0"
                                || formForm.dest_tras_store_id===0  || hasbeenshared)}  onClick={searchFormStoreAddress}>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>:
                            <IconButton  size="small" className="edit-noselect-button" disabled>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>
                        }
                    </div>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_PostalCode')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <span style={{ position: "relative" }}>
                                <TextField autoComplete="off"
                                    id="dest_tras_postalcode_code"
                                    name="dest_tras_postalcode_code"
                                    value={formForm.dest_tras_postalcode_code}
                                    onChange={(e) => {
                                          setFormForm(prev => ({
                                            ...prev,
                                            dest_tras_postalcode_code: e.target.value.toUpperCase()
                                        }));
                                        debouncedHandleSearchPostalCode(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownDPostalCodeDest}
                                    onBlur={(event) => {
                                        if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            const inputPostalCode = formForm.dest_tras_postalcode_code.trim().toUpperCase();
                                            const matchedPostal = postalCodeDestToSelect.find((postal) => {
                                            const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                            return normalizedPostal === inputPostalCode;
                                            });

                                            if (matchedPostal) {
                                                setFormForm((prev) => ({
                                                    ...prev,
                                                    dest_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                                    dest_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                                    dest_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                                    dest_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE), 
                                                    dest_tras_province_name: matchedPostal.province_name || DEFAULTPROVINCE_NAME
                                                }));
                                            } else {
                                                setFormForm((prev) => ({
                                                    ...prev,
                                                    dest_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                                    dest_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                                    dest_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                                    dest_tras_province_id: Number(DEFAULTPROVINCE),
                                                    aut_tras_province_name: DEFAULTPROVINCE_NAME
                                                }));
                                            }
                                            setFilteredpostalCodeDest([]);
                                            setHighlightedIndexPostalCodeDest(-1);
                                        }
                                    }}
                                    label={errorsForm.dest_tras_postalcode_code!=null && errorsForm.dest_tras_postalcode_code!==""?t(errorsForm.dest_tras_postalcode_code):t('Text_FORM_PostalCode')}
                                    placeholder={t('Text_FORM_PostalCode')}
                                    variant="standard"
                                    inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                />  
                                {/* Desplegable dinámico */}
                                {filteredpostalCodeDest.length > 0 && (
                                    <div
                                        className="dropdown-class"
                                        style={{
                                            position: "absolute",
                                            left:'0px',
                                            border: "2px solid #4e73df", // Borde azul (#4e73df)
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "700%", 
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa", // Fondo gris claro
                                            zIndex: 1000,   
                                        }}
                                        onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                        {filteredpostalCodeDest.map((postal, index) => (
                                        <MenuItem
                                            key={postal.id}
                                            onClick={() => handleSelectPostalCodeDest(postal)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor:
                                                index === highlightedIndexPostalCodeDest ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexPostalCodeDest ? "white" : "black",
                                            }}
                                        >
                                            {postal.postalcode} - {postal.name} - {postal.province_name}
                                        </MenuItem>
                                        ))}
                                    </div>
                                )}
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Locality')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="dest_tras_postalcode_name" 
                                name="dest_tras_postalcode_name"
                                value={formForm.dest_tras_postalcode_name}
                                inputProps={{ style: {width: i18n.language==='es'?473:503,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.dest_tras_postalcode_name!=null && errorsForm.dest_tras_postalcode_name!==""?t(errorsForm.dest_tras_contactname):t('Text_FORM_Locality')}
                                placeholder={t('Text_FORM_Locality')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Dest_Tras}
                                onChange={handleChangeDataEditForm_Dest_Tras}
                                disabled
                            />   
                        </div>
                    </div>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Community')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="dest_tras_community_id"
                                name="dest_tras_community_id"
                                value={ (formForm.dest_tras_community_id === undefined || formForm.dest_tras_community_id ===null || formForm.dest_tras_community_id ===""
                                    || formForm.dest_tras_community_id ==="0" || formForm.dest_tras_community_id ===0)?Number(DEFAULTCOMMUNITY):formForm.dest_tras_community_id}
                                inputProps={{ style: {width: i18n.language==='es'?250:250,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurSelectCommunity_Dest_Tras}
                                onChange={handleChangeSelectCommunity_Dest_Tras}
                                disabled={!dest_tras_handle_address || hasbeenshared}
                                helperText={errorsForm.dest_tras_community_id!=null  && errorsForm.dest_tras_community_id!==""?t(errorsForm.dest_tras_community_id):""}
                                select
                                SelectProps={{
                                    native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                    value: (formForm.dest_tras_community_id === undefined || formForm.dest_tras_community_id ===null || formForm.dest_tras_community_id ===""
                                        || formForm.dest_tras_community_id ==="0" || formForm.dest_tras_community_id ===0)?Number(DEFAULTCOMMUNITY): formForm.dest_tras_community_id
                                }}>
                                {communityToSelect.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {i18n.language==="es"?option.namees:option.nameen}
                                    </MenuItem>
                                ))}
                            </TextField>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Province')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="dest_tras_province_name" 
                                name="dest_tras_province_name"
                                value={formForm.dest_tras_province_name}
                                inputProps={{ style: {width: i18n.language==='es'?300:305,  fontSize: '18px', }, maxLength: 30 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.dest_tras_province_name!=null && errorsForm.dest_tras_province_name!==""?t(errorsForm.dest_tras_province_name):t('Text_FORM_Province')}
                                placeholder={t('Text_FORM_Province')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Dest_Tras}
                                onChange={handleChangeDataEditForm_Dest_Tras}
                                disabled
                            />
                        </div>
                    </div>
 
                      
                </>
            }    
            { (dest_tras_view_phone || dest_tras_view_email || dest_tras_view_nima) &&
                <div className="row p-2"> 
                    <div className="form-group">
                        {dest_tras_view_phone &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Phone')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField autoComplete="off"
                                    id="dest_tras_phone" 
                                    name="dest_tras_phone"
                                    value={formForm.dest_tras_phone}
                                    inputProps={{ style: {width: i18n.language==='es'?180:180,  fontSize: '18px', }, maxLength: 30 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.dest_tras_phone!=null && errorsForm.dest_tras_phone!==""?t(errorsForm.dest_tras_phone):t('PlaceHolder_FORM_Phone')}
                                    placeholder={t('PlaceHolder_FORM_Phone')}
                                    variant="standard"
                                    onBlur={handleBlurDataEditForm_Dest_Tras}
                                    onChange={handleChangeDataEditForm_Dest_Tras}
                                    disabled={!dest_tras_handle_phone || hasbeenshared}
                                />
                                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            </>
                        }
                        {dest_tras_view_email &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Email')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField autoComplete="off"
                                    id="dest_tras_email" 
                                    name="dest_tras_email"
                                    value={formForm.dest_tras_email}
                                    inputProps={{ style: {width:  (!dest_tras_view_phone || !dest_tras_view_nima)?(i18n.language==='es'?380:394):(i18n.language==='es'?181:197) ,  fontSize: '18px'}, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.dest_tras_email!=null && errorsForm.dest_tras_email!==""?t(errorsForm.dest_tras_email):t('PlaceHolder_FORM_Email')}
                                    placeholder={t('PlaceHolder_FORM_Email')}
                                    variant="standard"
                                    onBlur={handleBlurDataEditForm_Dest_Tras}
                                    onChange={handleChangeDataEditForm_Dest_Tras}
                                    disabled={!dest_tras_handle_email || hasbeenshared}
                                />
                                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            </>
                        }
                        {dest_tras_view_nima &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NIMA')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <span style={{ position: "relative" }}>
                                    <TextField autoComplete="off"
                                        id="dest_tras_nima"
                                        name="dest_tras_nima"
                                        value={formForm.dest_tras_nima}
                                        onChange={(e) => {
                                            setFormForm(prev => ({
                                            ...prev,
                                            dest_tras_nima: e.target.value.toUpperCase()
                                            }));
                                            debouncedHandleSearchDestTrasNima(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownDestTrasNima}
                                        onBlur={(event) => {
                                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                            }
                                        }}
                                        label={errorsForm.dest_tras_nima!=null && errorsForm.dest_tras_nima!==""?t(errorsForm.dest_tras_nima):t('PlaceHolder_FORM_NIMA')}
                                        placeholder={t('PlaceHolder_FORM_NIMA')}
                                        variant="standard"
                                        inputProps={{ style: {width: (!dest_tras_view_phone || !dest_tras_view_email)?133:133,  fontSize: '18px'}, maxLength: 50 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        disabled={!dest_tras_handle_nima || hasbeenshared}
                                    />  
                                    {/* Desplegable dinámico */}
                                    {filteredDestTrasNima.length > 0 && (
                                        <div
                                            className="dropdown-class"
                                            style={{
                                                position: "absolute",
                                                left:'0px',
                                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                                borderRadius: "4px",
                                                marginTop: "4px",
                                                maxHeight: "200px",
                                                maxWidth: "750px",
                                                overflowY: "auto",
                                                width: "100%",
                                                fontSize: '18px',
                                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                                zIndex: 1000,
                                            }}
                                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                        >
                                            {filteredDestTrasNima.map((nt, index) => (
                                            <MenuItem
                                                key={nt.id}
                                                onClick={() => handleSelectDestTrasNima(nt)}
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "8px",
                                                    borderBottom: "1px solid #eee",
                                                    fontSize: '18px',
                                                    backgroundColor:
                                                    index === highlightedIndexDestTrasNima ? "#4e73df" : "transparent",
                                                    color: index === highlightedIndexDestTrasNima ? "white" : "black",
                                                }}
                                            >
                                                {nt.nima}
                                            </MenuItem>
                                            ))}
                                        </div>
                                    )}
                                </span>
                                &nbsp;&nbsp;
                                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.dest_tras_documentid!==undefined && formForm.dest_tras_documentid!=="") ?
                                     <IconButton  size="small" className={`edit-${
                                        (formForm.dest_tras_store_id===undefined
                                            || formForm.dest_tras_store_id===""
                                            || formForm.dest_tras_store_id==="0"
                                            || formForm.dest_tras_store_id===0  || hasbeenshared)? "noselect-button": "select-button" }`}
                                            disabled={(formForm.dest_tras_store_id===undefined
                                            || formForm.dest_tras_store_id===""
                                            || formForm.dest_tras_store_id==="0"
                                            || formForm.dest_tras_store_id===0  || hasbeenshared)}  onClick={searchFormStoreNimaAddress}>
                                        <SearchIcon style={{fontSize: 28}}/>
                                    </IconButton>:
                                    <IconButton  size="small" className="edit-noselect-button" disabled>
                                        <SearchIcon style={{fontSize: 28}}/>
                                    </IconButton>
                                }
                            </>
                        }
                    </div>
                </div>  
            }
            { (dest_tras_view_inscription || dest_tras_view_opt) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {dest_tras_view_inscription &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_INSCRIPTION')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="dest_tras_inscription" 
                                name="dest_tras_inscription"
                                value={formForm.dest_tras_inscription}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !dest_tras_view_opt?350:250,  fontSize: '18px'}, maxLength: 50 }}
                                label={errorsForm.dest_tras_inscription!=null && errorsForm.dest_tras_inscription!==""?t(errorsForm.dest_tras_inscription):t('PlaceHolder_FORM_INSCRIPTION')}
                                placeholder={t('PlaceHolder_FORM_INSCRIPTION')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Dest_Tras}
                                onChange={handleChangeDataEditForm_Dest_Tras}
                                disabled={!dest_tras_handle_inscription || hasbeenshared}
                            />
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        </>
                    }
                    {dest_tras_view_opt &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_OPT')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="dest_tras_opt"
                                name="dest_tras_opt"
                                value={ (formForm.dest_tras_opt === undefined || formForm.dest_tras_opt ===null || formForm.dest_tras_opt ===""
                                    || formForm.dest_tras_opt ==="0" || formForm.dest_tras_opt ===0)?0:formForm.dest_tras_opt}
                                inputProps={{ style: {width: i18n.language==='es'?170:147,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurDataEditForm_Dest_Tras}
                                onChange={handleChangeDataEditForm_Dest_Tras} 
                                helperText={errorsForm.dest_tras_opt!=null?t(errorsForm.dest_tras_opt):""}
                                disabled={!dest_tras_handle_opt || hasbeenshared}
                                select
                                SelectProps={{
                                    native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                    value: (formForm.dest_tras_opt === undefined || formForm.dest_tras_opt ===null || formForm.dest_tras_opt ===""
                                        || formForm.dest_tras_opt ==="0" || formForm.dest_tras_opt ===0)?0: formForm.dest_tras_opt
                                }}>
                                <MenuItem key={0} value=""/>
                                {optTypeToSelect.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.code} - {option.namees.substring(0,20)}
                                </MenuItem>
                                ))}
                            </TextField>   
                        </>
                    }
                    </div>
                </div> 
            }

            { (dest_tras_view_cnae || dest_tras_view_licenseplate) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {dest_tras_view_cnae &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CNAE')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="dest_tras_cnae" 
                                name="dest_tras_cnae"
                                value={formForm.dest_tras_cnae}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !dest_tras_view_licenseplate?355:250,  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.dest_tras_cnae!=null && errorsForm.dest_tras_cnae!==""?t(errorsForm.dest_tras_cnae):t('PlaceHolder_FORM_CNAE')}
                                placeholder={t('PlaceHolder_FORM_CNAE')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Dest_Tras}
                                onChange={handleChangeDataEditForm_Dest_Tras}
                                disabled={!dest_tras_handle_cnae || hasbeenshared}
                            />
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        </>
                    }
                    {dest_tras_view_licenseplate &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Vehicles')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="dest_tras_licenseplate" 
                                name="dest_tras_licenseplate"
                                value={formForm.dest_tras_licenseplate}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !dest_tras_view_cnae?313:(i18n.language==='es'?313:324),  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.dest_tras_licenseplate!=null && errorsForm.dest_tras_licenseplate!==""?t(errorsForm.dest_tras_licenseplate):t('PlaceHolder_FORM_Vehicles')}
                                placeholder={t('PlaceHolder_FORM_Vehicles')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Dest_Tras}
                                onChange={handleChangeDataEditForm_Dest_Tras}
                                disabled={!dest_tras_handle_licenseplate || hasbeenshared}
                            />
                             &nbsp;&nbsp;
                            <IconButton  size="small"  style={{color:hasbeenshared?"#858796":"#e74a3b", fontSize: 18}} disabled={hasbeenshared}onClick={deleteDataVehicleDestTras}>
                                <DeleteIcon style={{fontSize: 28}}/>
                            </IconButton>
                            &nbsp;&nbsp;
                            {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                                <IconButton  size="small" className={`edit-${
                                    (formForm.dest_tras_store_id===undefined
                                        || formForm.dest_tras_store_id===""
                                        || formForm.dest_tras_store_id==="0"
                                        || formForm.dest_tras_store_id===0  || hasbeenshared)? "noselect-button": "select-button" }`}
                                        disabled={(formForm.dest_tras_store_id===undefined
                                        || formForm.dest_tras_store_id===""
                                        || formForm.dest_tras_store_id==="0"
                                        || formForm.dest_tras_store_id===0  || hasbeenshared)}  onClick={searchFormVehicles}>
                                    <SearchIcon style={{fontSize: 28}}/>
                                </IconButton>
                            } 
                        </>
                    }
                    </div>
                </div> 
            }
            {dest_tras_view_economicactivity &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Economicactivity')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="dest_tras_economicactivity" 
                        name="dest_tras_economicactivity"
                        value={formForm.dest_tras_economicactivity}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: i18n.language==='es'?659:685,  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.dest_tras_economicactivity!=null && errorsForm.dest_tras_economicactivity!==""?t(errorsForm.dest_tras_economicactivity):t('PlaceHolder_FORM_Economicactivity')}
                        placeholder={t('PlaceHolder_FORM_Economicactivity')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Dest_Tras}
                        onChange={handleChangeDataEditForm_Dest_Tras}
                        disabled={!dest_tras_handle_economicactivity || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            <FormSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Dest_Tras"}
                setFormForm={setFormForm}
            />
            <FormSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Dest_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.dest_tras_tradename}
                store_id={formForm.dest_tras_store_id}
                priority={4}
            />
            <FormSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Dest_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.dest_tras_tradename}
                store_id={formForm.dest_tras_store_id} 
            />

            <FormSearchStoreVehicles
                showModalSearchVehicles={showModalSearchVehicles}
                setShowModalSearchVehicles={setShowModalSearchVehicles}
                selectStores={"Dest_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.dest_tras_tradename}
                store_id={formForm.dest_tras_store_id}
            />

        </> 
    )
}

FormCreateOrEditDestTras.propTypes = {
    formForm: PropTypes.object.isRequired,
    setFormForm: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormForm: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired,
    hasbeenshared: PropTypes.bool.isRequired
  };
  
  export default FormCreateOrEditDestTras;